const initialGradeOfEvidence = {
  gradeOfEvidencePermissions: {},
  gradeOfEvidenceLists: [],
  gradeOfEvidenceStatus: [],
  changedGradeOfEvidenceStatus: [],
  loadingGradeOfEvidence: false,
  errorsGradeOfEvidence: {},
};

const gradeOfEvidenceReducer = (gradeOfEvidence = initialGradeOfEvidence, action) => {
  switch (action.type) {
    case "GET_GRADEOFEVIDENCELIST_PENDING":
    case "ADD_GRADE_OF_EVIDENCE_PENDING":
    case "UPDATE_GRADE_OF_EVIDENCE_PENDING":
    case "UPDATE_GRADE_OF_EVIDENCE_STATUS_PENDING":
    case "DELETE_GRADE_OF_EVIDENCE_PENDING":
    case "GET_GRADEOFEVIDENCELISTBYID_PENDING":
      return { ...gradeOfEvidence, loadingGradeOfEvidence: true };

    case "GET_GRADEOFEVIDENCELIST_FULFILLED":
      return {
        ...gradeOfEvidence,
        loadingGradeOfEvidence: false,
        gradeOfEvidenceLists: action.payload,
        gradeOfEvidenceCount: action.count,
        gradeOfEvidencePermissions: action.permissions,
      };

    case "ADD_GRADE_OF_EVIDENCE_FULFILLED":
    case "UPDATE_GRADE_OF_EVIDENCE_FULFILLED":
    case "UPDATE_GRADE_OF_EVIDENCE_STATUS_FULFILLED":
    case "DELETE_GRADE_OF_EVIDENCE_FULFILLED":
      return {
        ...gradeOfEvidence,
        loadingGradeOfEvidence: false,
        changedGradeOfEvidenceStatus: action.payload,
      };

    case "GET_GRADEOFEVIDENCELISTBYID_FULFILLED":
      return {
        ...gradeOfEvidence,
        loadingGradeOfEvidence: false,
        gradeOfEvidenceLists: action.payload,
      };

    case "RESET_DELETE_GRADE_OF_EVIDENCE_STATUS":
      return {
        ...gradeOfEvidence,
        loadingGradeOfEvidence: false,
        gradeOfEvidenceStatus: {},
        changedGradeOfEvidenceStatus: [],
        errorsGradeOfEvidence: {},
      };

    case "GET_GRADEOFEVIDENCELIST_REJECTED":
    case "ADD_GRADE_OF_EVIDENCE_REJECTED":
    case "UPDATE_GRADE_OF_EVIDENCE_REJECTED":
    case "UPDATE_GRADE_OF_EVIDENCE_STATUS_REJECTED":
    case "DELETE_GRADE_OF_EVIDENCE_REJECTED":
    case "GET_GRADEOFEVIDENCELISTBYID_REJECTED":
      return {
        ...gradeOfEvidence,
        loadingGradeOfEvidence: false,
        errorsGradeOfEvidence: action.payload,
      };

    default:
      return gradeOfEvidence;
  }
};

export default gradeOfEvidenceReducer;
